/* eslint-disable @typescript-eslint/no-var-requires */
const { ConfigPublic, required } = require('./config.public');

const EnvAsBool = (envVariable) => {
  return envVariable === 'true';
};

const ConfigServer = () => {
  return {
    NodeEnv: process.env.NODE_ENV,
    BuildEnv: required('BUILD_ENV', process.env.BUILD_ENV),
    ShowGitInfo: process.env.SHOW_GIT_INFO ?? false,
    GitBranch: process.env.GIT_BRANCH ?? 'local',
    GitClosestTag: process.env.GIT_CLOSEST_TAG ?? 'local',
    SearchPageEnabled: EnvAsBool(process.env.SEARCH_PAGE_ENABLED), // TODO: Remove this when search page is released
    Public: ConfigPublic,
    ServerSide: {
      CookieDomain: required('ELYSIUM_COOKIE_DOMAIN', process.env.ELYSIUM_COOKIE_DOMAIN),
      CookieSecure: required('ELYSIUM_COOKIE_SECURE', process.env.ELYSIUM_COOKIE_SECURE),
      InternalBffBaseUrl: required('INTERNAL_BFF_BASE_URL', process.env.INTERNAL_BFF_BASE_URL),
      ElysiumCookieName: required('ELYSIUM_COOKIE_NAME', process.env.ELYSIUM_COOKIE_NAME),
    },
  };
};

module.exports = {
  ConfigServer,
};
